export default __webpack_public_path__ + "static/media/sbcr.0287c34b.png";